import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelSettingsRolesAddResolverErrorStatesEnum {
    GetPermissionsFailed = ErrorStateScheduleEnum.PanelSettingsRolesAddResolverStatesStartIndex,
    PermissionsNotFound
}
